import { useTranslation } from "react-i18next";

import type { UiTheme } from "../theme";
import { Badge } from "./Badge";

// PG-64: the mark of a premium item that nobody can unlock yet. A word and a
// star, never the grey of a disabled control alone. It points nowhere: no
// link, no price, no upgrade path.
export function PremiumBadge({ theme }: { theme: UiTheme }) {
  const { t } = useTranslation();
  const label = t("mobile.premium.badge", { defaultValue: "Premium" });
  // a11yLabel makes the pill ONE node, the star silent inside it.
  return <Badge theme={theme} icon="star" label={label} a11yLabel={label} />;
}
